import React from 'react';
import PageLayout from './PageLayout';
import { useTranslation } from 'react-i18next';

const SchoolIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M22 10l-10-5-10 5 10 5z"/>
    <path d="M6 12v5c0 2 2 3 6 3s6-1 6-3v-5"/>
  </svg>
);

const MapPinIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z"/>
    <circle cx="12" cy="10" r="3"/>
  </svg>
);

const MailIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect width="20" height="16" x="2" y="4" rx="2"/>
    <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"/>
  </svg>
);

const LinkedInIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
  </svg>
);

const Connect = () => {
  const { t } = useTranslation();

  return (
    <PageLayout>
      <div className="contact-container">
        <h2 className="page-first-heading">{t('connect.title')}</h2>
        <div className="contact-grid">
          {/* 所属カード */}
          <div className="contact-card">
            <div className="contact-icon">
              <SchoolIcon />
            </div>
            <div className="contact-details">
              <h3>{t('connect.affiliation')}</h3>
              <p>
                {t('connect.affiliationText').split('\n').map((line, i) => (
                  <React.Fragment key={i}>
                    {i > 0 && <br />}
                    {line}
                  </React.Fragment>
                ))}
              </p>
            </div>
          </div>

          {/* 住所カード */}
          <div className="contact-card">
            <div className="contact-icon">
              <MapPinIcon />
            </div>
            <div className="contact-details">
              <h3>{t('connect.address')}</h3>
              <p>
                {t('connect.addressText').split('\n').map((line, i) => (
                  <React.Fragment key={i}>
                    {i > 0 && <br />}
                    {line}
                  </React.Fragment>
                ))}
              </p>
            </div>
          </div>

          {/* メールカード */}
          <div className="contact-card">
            <div className="contact-icon">
              <MailIcon />
            </div>
            <div className="contact-details">
              <h3>{t('connect.email')}</h3>
              <p>
                {t('connect.emailDesc')}<br />
                <a href="mailto:sota.yo4da@gmail.com">sota.yo4da@gmail.com</a>
              </p>
            </div>
          </div>

          {/* LinkedInカード */}
          <div className="contact-card">
            <div className="contact-icon">
              <LinkedInIcon />
            </div>
            <div className="contact-details">
              <h3>{t('connect.linkedin')}</h3>
              <p>
                {t('connect.linkedinDesc')}<br />
                <a 
                  href="https://www.linkedin.com/in/Yo4da-Sota-166166372" 
                  target="_blank" 
                  rel="noopener noreferrer"
                >
                  Sota Yoshida
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </PageLayout>
  );
};

export default Connect;